import DownloadUser from "./DownloadUser";
import AdminLayout from "./UserLayout";
import OperatorAccount from "./OperatorAccount";
import DownloadUserResetPassword from "./DownloadUser/ResetPassword";
import DownloadUserForgotPassword from "./DownloadUser/ForgotPassword";

const module = {
  routeProps: {
    path: "User",
    component: AdminLayout,
  },
  name: "User",
  label: "User",
  submodules: [
    DownloadUser,
    OperatorAccount,
    DownloadUserResetPassword,
    DownloadUserForgotPassword,
  ],
  showOnHeader: true,
};
export default module;
